import Hero from '../components/Hero'
import { Link } from 'react-router-dom'

export default function Home() {
	return (
		<div>
			<Hero />
			<section className="container-gg py-12">
				<div className="grid gap-10 md:grid-cols-2 md:items-center">
					<div>
						<p className="text-sm font-semibold uppercase tracking-wide text-brand">Why families choose us</p>
						<h2 className="mt-2 text-3xl font-bold text-slate-900">We are a Christ-centered school focused on whole-child development</h2>
						<p className="mt-4 text-slate-600">
							From our playful Nursery classrooms to our leadership-focused Secondary college, GreatGrace Int&apos;l School blends rigorous academics, creativity, spiritual formation, and life skills. Students learn in small communities, guided by passionate teachers who know every learner by name.
						</p>
					</div>
					<ul className="space-y-4 rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
						<li className="flex gap-4">
							<div className="mt-1 h-2 w-2 rounded-full bg-brand" />
							<div>
								<p className="font-semibold text-slate-900">Day School: Nursery to Secondary</p>
								<p className="text-sm text-slate-600">Flexible arrival and pick-up routines, extended learning labs, and vibrant clubs.</p>
							</div>
						</li>
						<li className="flex gap-4">
							<div className="mt-1 h-2 w-2 rounded-full bg-brand" />
							<div>
								<p className="font-semibold text-slate-900">Boarding: Secondary only</p>
								<p className="text-sm text-slate-600">A nurturing residence with supervised study, mentorship, and weekend enrichment.</p>
							</div>
						</li>
						<li className="flex gap-4">
							<div className="mt-1 h-2 w-2 rounded-full bg-brand" />
							<div>
								<p className="font-semibold text-slate-900">Signature programs</p>
								<p className="text-sm text-slate-600">STEM labs, visual &amp; performing arts, entrepreneurship, missions/outreach, and sports.</p>
							</div>
						</li>
					</ul>
				</div>
			</section>

			<section className="bg-slate-50 py-12">
				<div className="container-gg">
					<h2 className="text-2xl font-bold text-slate-900">Our Schools</h2>
					<div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
						<div className="rounded-2xl border border-slate-200 bg-white p-6">
							<h3 className="font-semibold text-slate-900">Nursery School</h3>
							<p className="mt-2 text-sm text-slate-600">Safe play-based classrooms with strong phonics, numeracy, music, and faith formation.</p>
							<p className="mt-3 rounded-full bg-slate-100 px-4 py-1 text-xs font-semibold uppercase text-slate-700">Day school</p>
						</div>
						<div className="rounded-2xl border border-slate-200 bg-white p-6">
							<h3 className="font-semibold text-slate-900">Primary School</h3>
							<p className="mt-2 text-sm text-slate-600">Inquiry-based learning, digital literacy, French, coding, arts, and outdoor education.</p>
							<p className="mt-3 rounded-full bg-slate-100 px-4 py-1 text-xs font-semibold uppercase text-slate-700">Day school</p>
						</div>
						<div className="rounded-2xl border border-slate-200 bg-white p-6">
							<h3 className="font-semibold text-slate-900">Secondary College</h3>
							<p className="mt-2 text-sm text-slate-600">Cambridge-aligned curriculum, leadership internships, and exam readiness with dedicated mentors.</p>
							<div className="mt-3 flex flex-wrap gap-2">
								<span className="rounded-full bg-slate-100 px-4 py-1 text-xs font-semibold uppercase text-slate-700">Day school</span>
								<span className="rounded-full bg-emerald-100 px-4 py-1 text-xs font-semibold uppercase text-emerald-800">Boarding available</span>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="container-gg py-12">
				<div className="grid gap-6 md:grid-cols-2">
					<div className="rounded-2xl border border-slate-200 p-6 shadow-sm">
						<p className="text-sm font-semibold uppercase tracking-wide text-brand">Day School Experience</p>
						<h3 className="mt-2 text-2xl font-bold text-slate-900">Flexible schedules that honor family rhythms</h3>
						<p className="mt-3 text-sm text-slate-600">Parents can select early drop-off, after-school care, and Saturday mastery labs for music, robotics, dance, coding, and sports.</p>
						<ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-slate-600">
							<li>Personalized learning &amp; advisory</li>
							<li>Clubs, missions, chapel, and mentorship</li>
							<li>Hot meals and healthy snacks prepared on campus</li>
						</ul>
					</div>
					<div className="rounded-2xl border border-slate-200 p-6 shadow-sm">
						<p className="text-sm font-semibold uppercase tracking-wide text-brand">Boarding House (Secondary)</p>
						<h3 className="mt-2 text-2xl font-bold text-slate-900">A caring home-away-from-home</h3>
						<p className="mt-3 text-sm text-slate-600">Secondary students live in modern dorms with house parents, daily devotions, supervised prep, weekend excursions, and leadership coaching.</p>
						<ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-slate-600">
							<li>Separated hostels for boys &amp; girls</li>
							<li>Medical bay with resident nurse</li>
							<li>Career counseling and university prep</li>
						</ul>
					</div>
				</div>
			</section>

			<section className="bg-slate-50 py-12">
				<div className="container-gg">
					<div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
						<div>
							<p className="text-sm font-semibold uppercase tracking-wide text-brand">Apply anytime</p>
							<h2 className="text-2xl font-bold text-slate-900">Ready to enroll your child?</h2>
							<p className="mt-2 text-sm text-slate-600">Click below to submit your interest for Nursery, Primary, or Secondary (day or boarding).</p>
						</div>
						<Link to="/admissions" className="btn-primary">Begin Enrollment</Link>
					</div>
				</div>
			</section>
		</div>
	)
}






